export const DocUploadGizmo = ({ width = 220, height = 200 }) => (
  <svg width={width} height={height} viewBox="0 0 220 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Document shadow */}
    <rect x="42" y="24" width="136" height="158" rx="10" fill="hsl(var(--nextui-primary) / 0.2)" opacity="0.5" />
    {/* Document body */}
    <rect x="36" y="18" width="136" height="158" rx="10" fill="hsl(var(--nextui-primary) / 0.1)" />
    {/* Folded corner */}
    <path d="M136 18 L172 54 L136 54 Z" fill="hsl(var(--nextui-primary) / 0.35)" />
    <path d="M136 18 L172 54 H136 V18 Z" fill="hsl(var(--nextui-primary) / 0.2)" />
    {/* Text lines */}
    <rect x="56" y="72" width="96" height="6" rx="3" fill="hsl(var(--nextui-primary) / 0.35)" />
    <rect x="56" y="86" width="80" height="6" rx="3" fill="hsl(var(--nextui-primary) / 0.35)" />
    <rect x="56" y="100" width="88" height="6" rx="3" fill="hsl(var(--nextui-primary) / 0.35)" />
    <rect x="56" y="114" width="64" height="6" rx="3" fill="hsl(var(--nextui-primary) / 0.35)" />
    <rect x="56" y="128" width="76" height="6" rx="3" fill="hsl(var(--nextui-primary) / 0.35)" />
    {/* Upload circle background */}
    <circle cx="164" cy="148" r="36" fill="var(--urtentic-sdk-primary, #255CFF)" />
    {/* Upload arrow */}
    <path d="M164 162 L164 138" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M155 147 L164 138 L173 147" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    {/* Upload base line */}
    <path d="M155 165 L173 165" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);
